<template>
  <div
    style="background: #101010; min-height: 100vh; height: auto; background-size: cover; padding-bottom: 15rem; background-attachment: fixed;"
  >
    <!-- 431044 -->
    <Sticky>
      <div>
        <NavBar />

        <div
          class="d-flex px-0 px-3 mx-auto my-2"
          style="width: 97%;z-index: 10; padding-top: 2px; padding-bottom: 2px; background: #151515 !important; border-radius: 5px;"
        >
          <i
            class="fas fa-volume-up my-auto text-white pr-3"
            style="font-size: 14px; font-weight: 600;"
          ></i>
          <NoticeBar
            class="mx-0 px-0 mx-auto notice-bar col-11"
            scrollable
            speed="40"
            :text="websiteInfo.noticeText"
            v-if="!threedData.embedded_link && !threedData.isLive"
          />
          <!-- websiteInfo[0]?.noticeText  -->
        </div>

        <div class="col-lg-12 px-2 col-12 mx-auto d-flex main-image-wrapper">
          <b-carousel
            id="carousel-1"
            :interval="3000"
            controls
            fade
            style="width: 100%; height: 100%;"
          >
            <b-carousel-slide
              img-src="https://storage.googleapis.com/spacetech2/cr7/assets/promo1.avif"></b-carousel-slide>
            <b-carousel-slide
              img-src="https://storage.googleapis.com/spacetech2/cr7/assets/promo2.avif"></b-carousel-slide>
            <b-carousel-slide
              img-src="https://storage.googleapis.com/spacetech2/cr7/assets/promo3.avif"></b-carousel-slide>
            <b-carousel-slide
              img-src="https://storage.googleapis.com/spacetech2/cr7/assets/promo4.avif"></b-carousel-slide>
            <b-carousel-slide
              img-src="https://storage.googleapis.com/spacetech2/cr7/assets/promo5.avif"></b-carousel-slide>
            <b-carousel-slide
              img-src="https://storage.googleapis.com/spacetech2/cr7/assets/promo6.avif"></b-carousel-slide>
          </b-carousel>
        </div>



        <!-- <div class="my-3 text-center py-2" style="background: #F4DC83; font-weight: 900; color: black;">
          TOP GAMES
        </div> -->
      </div>
    </Sticky>


    <div class="home-side-nav w-100 d-flex align-items-stretch pt-3 pb-2 px-1">
      <div class="home-side-nav-item">
        <div
          class="side-nav-icon home-side-nav-tile d-flex flex-column align-items-center justify-content-start mx-auto"
          :class="$store.state.sideNav === 'hot' ? 'active' : ''"
          @click="changeSideNav('hot');"
        >
          <img
            :src="'https://storage.googleapis.com/spacetech2/cr7/assets/hot (2).avif'"
            class="home-side-nav-icon-img"
            alt=""
          >
          <span
            class="side-nav-icon-text home-side-nav-label"
            :class="$store.state.sideNav === 'hot' ? 'active' : ''"
          >{{ $t('home.hot') }}</span>
        </div>
      </div>
      <div class="home-side-nav-item">
        <div
          class="side-nav-icon home-side-nav-tile d-flex flex-column align-items-center mx-auto"
          :class="$store.state.sideNav === 'slot' ? 'active' : ''"
          @click="changeSideNav('slot');"
        >
          <img
            :src="'https://storage.googleapis.com/spacetech2/cr7/assets/slot (2).avif'"
            class="home-side-nav-icon-img"
            alt=""
          >
          <span
            class="side-nav-icon-text home-side-nav-label"
            :class="$store.state.sideNav === 'slot' ? 'active' : ''"
          >{{ $t('home.slot') }}</span>
        </div>
      </div>
      <div class="home-side-nav-item">
        <div
          class="side-nav-icon home-side-nav-tile d-flex flex-column align-items-center mx-auto"
          :class="$store.state.sideNav === 'card' ? 'active' : ''"
          @click="changeSideNav('card');"
        >
          <img
            :src="'https://storage.googleapis.com/spacetech2/cr7/assets/card (2).avif'"
            class="home-side-nav-icon-img"
            alt=""
          >
          <span
            class="side-nav-icon-text home-side-nav-label"
            :class="$store.state.sideNav === 'card' ? 'active' : ''"
          >{{ $t('home.card') }}</span>
        </div>
      </div>
      <div class="home-side-nav-item">
        <div
          class="side-nav-icon home-side-nav-tile d-flex flex-column align-items-center mx-auto"
          :class="$store.state.sideNav === 'fishing' ? 'active' : ''"
          @click="changeSideNav('fishing');"
        >
          <img
            :src="'https://storage.googleapis.com/spacetech2/cr7/assets/fishing (2).avif'"
            class="home-side-nav-icon-img"
            alt=""
          >
          <span
            class="side-nav-icon-text home-side-nav-label"
            :class="$store.state.sideNav === 'fishing' ? 'active' : ''"
          >{{ $t('home.fishing') }}</span>
        </div>
      </div>
      <div class="home-side-nav-item">
        <div
          class="side-nav-icon home-side-nav-tile d-flex flex-column align-items-center mx-auto"
          role="button"
          tabindex="0"
          @click="redirectRoute('/user/slots', { provider: 'Buffalo' })"
          @keyup.enter="redirectRoute('/user/slots', { provider: 'Buffalo' })"
        >
          <img
            :src="'https://storage.googleapis.com/spacetech2/cr7/assets/buffalo (2).avif'"
            class="home-side-nav-icon-img"
            alt=""
          >
          <span class="side-nav-icon-text home-side-nav-label">{{ $t('home.buffalo') }}</span>
        </div>
      </div>
      <!-- <div class="home-side-nav-item">
        <div
          class="side-nav-icon home-side-nav-tile d-flex flex-column align-items-center mx-auto"
          :class="$store.state.sideNav === 'arcade' ? 'active' : ''"
          @click="changeSideNav('arcade');"
        >
          <div class="home-side-nav-icon-wrap">
            <img
              :src="'https://storage.googleapis.com/spacetech2/cr7/assets/arcade.avif'"
              class="home-side-nav-icon-img"
              :alt="$t('home.arcade')"
            >
          </div>
          <span
            class="side-nav-icon-text home-side-nav-label"
            :class="$store.state.sideNav === 'arcade' ? 'active' : ''"
          >{{ $t('home.arcade') }}</span>
        </div>
      </div> -->
      <div class="home-side-nav-item">
        <div
          class="side-nav-icon home-side-nav-tile d-flex flex-column align-items-center mx-auto"
          :class="$store.state.sideNav === 'liveCasino' ? 'active' : ''"
          @click="changeSideNav('liveCasino');"
        >
          <img
            :src="'https://storage.googleapis.com/spacetech2/cr7/assets/casino (2).avif'"
            class="home-side-nav-icon-img home-side-nav-icon-img--compact"
            alt=""
          >
          <span
            class="side-nav-icon-text home-side-nav-label"
            :class="$store.state.sideNav === 'liveCasino' ? 'active' : ''"
          >{{ $t('home.live_casino') }}</span>
        </div>
      </div>
      <!-- <div class="nav-item mx-auto">
          <div class="side-nav-icon d-flex flex-column pt-0 mx-auto" :class="$store.state.sideNav === 'football' ? 'active': ''" style="padding-top: 0.8rem !important; width: 90%; height: 6rem; border-radius: 10px;" @click="changeSideNav('football');">
            <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/hulk333/general/icon_g_sport.webp" class="mx-auto p-0 m-0 " style="cursor: pointer; width: 4.5rem;">
            <span class="mx-auto side-nav-icon-text" :class="$store.state.sideNav === 'football' ? 'active': ''">{{$t('home.football')}}</span>
          </div>
        </div> -->
      <!-- </ul> -->
    </div>
    <div class="cards-container-mobile">
      <div
        class="container-fluid justify-content-end px-0 d-flex pt-0"
        style="position: relative;"
      >
        <!-- <div class="col-12"> -->

        <div
          class="index_rightbar mr-0 pl-0 col-12 pl-2 pr-1"
          id="index_rightbar"
          style="height: 90vh; overflow-y: scroll; position: absolute;"
        >
          <div
            :style="($store.state.sideNav === 'slot' || $store.state.sideNav === 'hot') ? 'height: 110vh' : 'height: 50vh'"
          >
            <div
              class="tab-content game px-2"
              style="min-height: 50vh; border-radius: 20px; height: auto; padding-bottom: 30rem;"
            >

              <div
                class="mx-1 mt-0"
                :class="$store.state.sideNav === 'hot' ? 'active' : ''"
                v-show="$store.state.sideNav === 'hot'"
              >
                <div>
                  <!-- <img src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/hulk333/jackpot_bg.jpg" alt="" style="width: 100%; height: auto; border-top-left-radius: 10px; border-top-right-radius: 10px; border-bottom-right-radius: 5px; border-bottom-left-radius: 5px;"> -->
                  <div class="col-12 p-0 py-1">
                    <div class="d-flex">
                      <div>
                        <h4
                          class=" text-nowrap"
                          style="color: #fff;"
                        >{{ $t('home.popular_slot_games') }}</h4>
                      </div>
                      <div
                        class="my-auto ml-3 pb-2"
                        style="width: 100%; border-top: 1px solid #2C2C2D; height: 0px;"
                      ></div>
                    </div>

                    <div class="d-flex flex-wrap">
                      <div
                        class="col-3 px-1 my-2"
                        v-for="slotGame in hotGames['slotGames']"
                        :key="slotGame.id"
                      >
                        <div
                          class="pb-1 position-relative"
                          style="cursor: pointer;"
                          @click="gameInit(slotGame)"
                        >
                          <img
                            style="width: 25px; position: absolute; right: 10px; top: -15px; z-index: 2;"
                            src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/dae6345e-9f8a-471a-a361-ce0d318af400/public"
                            alt=""
                          >
                          <div class="home-hot-game-thumb">
                            <GameThumbImg
                              :src="imageLinkGenerate(slotGame.gameID, slotGame.provider)"
                              :alt="hotGameDisplayName(slotGame) || 'Game'"
                            />
                          </div>
                          {{ hotGameDisplayName(slotGame) }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 p-0 py-1">
                    <div class="d-flex">
                      <div>
                        <h4
                          class="text-nowrap"
                          style="color: #fff;"
                        >{{ $t('home.popular_fishing_games') }}</h4>
                      </div>
                      <div
                        class="my-auto ml-3 pb-2"
                        style="width: 100%; border-top: 1px solid #2C2C2D; height: 0px;"
                      ></div>
                    </div>

                    <div class="d-flex flex-wrap">
                      <div
                        class="col-3 px-1 my-2"
                        v-for="slotGame in hotGames['fishingGames']"
                        :key="slotGame.id"
                      >
                        <div
                          class="pb-1 position-relative"
                          style="cursor: pointer;"
                          @click="gameInit(slotGame)"
                        >
                          <img
                            style="width: 25px; position: absolute; right: 10px; top: -15px; z-index: 2;"
                            src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/dae6345e-9f8a-471a-a361-ce0d318af400/public"
                            alt=""
                          >
                          <div class="home-hot-game-thumb">
                            <GameThumbImg
                              :src="imageLinkGenerate(slotGame.gameID, slotGame.provider)"
                              alt="Game"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="col-12 p-0 py-1">
                    <div class="d-flex">
                      <div>
                        <h4
                          class="text-nowrap"
                          style="color: #fff;"
                        >{{ $t('home.popular_arcade_games') }}</h4>
                      </div>
                      <div
                        class="my-auto ml-3 pb-2"
                        style="width: 100%; border-top: 1px solid #2C2C2D; height: 0px;"
                      ></div>
                    </div>

                    <div class="d-flex flex-wrap">
                      <div
                        class="col-3 px-1 my-2"
                        v-for="slotGame in hotGames['arcadeGames']"
                        :key="slotGame.id"
                      >
                        <div
                          class="pb-1 position-relative"
                          style="cursor: pointer;"
                          @click="gameInit(slotGame)"
                        >
                          <img
                            style="width: 25px; position: absolute; right: 10px; top: -15px; z-index: 2;"
                            src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/dae6345e-9f8a-471a-a361-ce0d318af400/public"
                            alt=""
                          >
                          <div class="home-hot-game-thumb">
                            <GameThumbImg
                              :src="imageLinkGenerate(slotGame.gameID, slotGame.provider)"
                              alt="Game"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



              <!-- <div class="mx-1" :class="this.$store.state.sideNav === 'vs' ? 'active' : ''" v-show="this.$store.state.sideNav === 'vs'">
                    <img src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/723ca88a-6cf0-406b-d7b3-a93d023f6f00/public" alt="slot" style="cursor: pointer; width: 103%; margin-left: -0.4rem; height: auto;" @click="gameInit('CockFight')">
                  </div> -->

              <div
                :class="$store.state.sideNav === 'skm' ? 'active' : ''"
                v-if="$store.state.sideNav === 'skm'"
              >
                <img
                  class="mx-1 my-1"
                  src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%9C%E1%80%B0%E1%80%9E%E1%80%85%E1%80%BA.png"
                  alt="skm"
                  style="cursor: pointer; width: 31%; height: auto;"
                  @click="fetchShanKoMeeData(0)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%82%E1%80%BB%E1%80%B0%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
                  alt="skm"
                  style="cursor: pointer; width: 31%; height: auto;"
                  @click="fetchShanKoMeeData(1)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%85%E1%80%AE%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
                  alt="skm"
                  style="cursor: pointer; width: 31%; height: auto;"
                  @click="fetchShanKoMeeData(2)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%98%E1%80%B1%E1%80%AC%E1%80%B7%E1%80%85%E1%80%BA.png"
                  alt="skm"
                  style="cursor: pointer; width: 31%; height: auto;"
                  @click="fetchShanKoMeeData(3)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%99%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
                  alt="skm"
                  style="cursor: pointer; width: 31%; height: auto;"
                  @click="fetchShanKoMeeData(4)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%98%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
                  alt="skm"
                  style="cursor: pointer; width: 31%; height: auto;"
                  @click="fetchShanKoMeeData(5)"
                >
              </div>

              <div
                :class="$store.state.sideNav === 'bgy' ? 'active' : ''"
                v-if="$store.state.sideNav === 'bgy'"
              >
                <img
                  class="mx-1 my-1"
                  src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%9C%E1%80%B0%E1%80%9E%E1%80%85%E1%80%BA.png"
                  alt="bgy"
                  style="cursor: pointer; width: 31%; height: auto;"
                  @click="fetchBugyee(0)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%82%E1%80%BB%E1%80%B0%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
                  alt="bgy"
                  style="cursor: pointer; width: 31%; height: auto;"
                  @click="fetchBugyee(1)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%85%E1%80%AE%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
                  alt="bgy"
                  style="cursor: pointer; width: 31%; height: auto;"
                  @click="fetchBugyee(2)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%98%E1%80%B1%E1%80%AC%E1%80%B7%E1%80%85%E1%80%BA.png"
                  alt="bgy"
                  style="cursor: pointer; width: 31%; height: auto;"
                  @click="fetchBugyee(3)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%99%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
                  alt="bgy"
                  style="cursor: pointer; width: 31%; height: auto;"
                  @click="fetchBugyee(4)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/%E1%80%98%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
                  alt="bgy"
                  style="cursor: pointer; width: 31%; height: auto;"
                  @click="fetchBugyee(5)"
                >
              </div>

              <div
                class="home-provider-grid pb-3 d-flex justify-content-between flex-wrap"
                :class="$store.state.sideNav === 'fishing' ? 'active' : ''"
                v-if="$store.state.sideNav === 'fishing'"
              >
                <img
                  src="https://storage.googleapis.com/spacetech2/cr7/Jili-Fish.avif"
                  alt="Jili"
                  class="home-provider-card"
                  @click="$router.push('/user/fishing?provider=Jili')"
                >
                <img
                  :src="'https://storage.googleapis.com/spacetech2/cr7/2J-Fish.avif'"
                  alt="2J"
                  class="home-provider-card"
                  @click="$router.push('/user/fishing?provider=2J')"
                >
                <img
                  :src="'https://storage.googleapis.com/spacetech2/cr7/JDB-Fish.avif'"
                  alt="JDB"
                  class="home-provider-card"
                  @click="$router.push('/user/fishing?provider=JDB')"
                >
                <!-- <img
                  :src="'https://storage.googleapis.com/spacetech2/cr7/BNG-Fish.avif'"
                  alt="BNG"
                  class="home-provider-card"
                  @click="$router.push('/user/fishing?provider=BNG')"
                >
                <img
                  :src="'https://storage.googleapis.com/spacetech2/cr7/BT-Fish.avif'"
                  alt="BTG"
                  class="home-provider-card"
                  @click="$router.push('/user/fishing?provider=BTG')"
                > -->
                <img
                  :src="'https://storage.googleapis.com/spacetech2/cr7/KA-Fish.avif'"
                  alt="KA"
                  class="home-provider-card"
                  @click="$router.push('/user/fishing?provider=KA')"
                >
                <img
                  :src="'https://storage.googleapis.com/spacetech2/cr7/AceWin-Fish.avif'"
                  alt="AceWin"
                  class="home-provider-card"
                  @click="$router.push('/user/fishing?provider=AceWin')"
                >
                <img
                  :src="'https://storage.googleapis.com/spacetech2/cr7/FC-Fish.avif'"
                  alt="FaChai"
                  class="home-provider-card"
                  @click="$router.push('/user/fishing?provider=FaChai')"
                >
              </div>

              <div
                :class="$store.state.sideNav === 'slot' ? 'active' : ''"
                v-if="$store.state.sideNav === 'slot'"
                class="home-provider-grid pb-2 mx-0 px-0 d-flex justify-content-between flex-wrap"
              >
                <img
                  src="https://storage.googleapis.com/spacetech2/cr7/PP.avif"
                  alt="Pragmatic"
                  class="home-provider-card"
                  @click="$router.push('/user/slots?provider=Pragmatic')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/cr7/Jili.avif"
                  alt="Jili"
                  class="home-provider-card"
                  @click="$router.push('/user/slots?provider=Jili')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/cr7/2J.avif"
                  alt="2J"
                  class="home-provider-card"
                  @click="$router.push('/user/slots?provider=2J')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/cr7/Rich.avif"
                  alt="Rich"
                  class="home-provider-card"
                  @click="$router.push('/user/slots?provider=Rich')"
                >
                <!-- <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/samurai81/downloads/samurai_bng.webp" alt="skm" class="home-provider-card" @click="$router.push('/user/slots?provider=BNG')"> -->
                <img
                  src="https://storage.googleapis.com/spacetech2/cr7/BTG.avif"
                  alt="BTG"
                  class="home-provider-card"
                  @click="$router.push('/user/slots?provider=BTG')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/cr7/VA.avif"
                  alt="VA"
                  class="home-provider-card"
                  @click="$router.push('/user/slots?provider=VA')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/cr7/Live22.avif"
                  alt="Live22"
                  class="home-provider-card"
                  @click="$router.push('/user/slots?provider=Live22')"
                >
                <!-- <img
                  src="https://storage.googleapis.com/spacetech2/cr7/PG%20IC.webp"
                  alt="PGSoft"
                  class="home-provider-card"
                  @click="$router.push('/user/slots?provider=PGSoft')"
                > -->
                <img
                  src="https://storage.googleapis.com/spacetech2/cr7/5G.avif"
                  alt="5G"
                  class="home-provider-card"
                  @click="$router.push('/user/slots?provider=5G')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/cr7/AceWin.avif"
                  alt="AceWin"
                  class="home-provider-card"
                  @click="$router.push('/user/slots?provider=AceWin')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/cr7/BNG.avif"
                  alt="BNG"
                  class="home-provider-card"
                  @click="$router.push('/user/slots?provider=BNG')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/cr7/R88.avif"
                  alt="Rich88"
                  class="home-provider-card"
                  @click="$router.push('/user/slots?provider=Rich88')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/cr7/JDB.avif"
                  alt="JDB"
                  class="home-provider-card"
                  @click="$router.push('/user/slots?provider=JDB')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/cr7/Hotdog.avif"
                  alt="HotDog"
                  class="home-provider-card"
                  @click="$router.push('/user/slots?provider=HotDog')"
                >

                <!-- <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/samurai81/logo/samurai_pp.png" alt="skm" class="home-provider-card" @click="$router.push('/user/slots?provider=JOKER')"> -->
                <img
                  src="https://storage.googleapis.com/spacetech2/cr7/FC.avif"
                  alt="FaChai"
                  class="home-provider-card"
                  @click="$router.push('/user/slots?provider=FaChai')"
                >
                <!-- <img
                  src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/samurai81/logo/samurai_spade.png"
                  alt="skm"
                  class="my-2 px-0 mx-0"
                  style="cursor: pointer; width: 31%; height: auto;"
                  @click="$router.push('/user/slots?provider=Spade')"
                > -->
                <!-- <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/cards/ak47-pp-new.png" alt="skm" class="my-2 px-0 mx-0" style="cursor: pointer; width: 31%; height: auto;" @click="$router.push('/user/slots?provider=5G')">
                    <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/cards/ak47-pp-new.png" alt="skm" class="my-2 px-0 mx-0" style="cursor: pointer; width: 31%; height: auto;" @click="$router.push('/user/slots?provider=Playstar')"> -->



              </div>

              <div
                :class="$store.state.sideNav === 'football' ? 'active' : ''"
                v-if="$store.state.sideNav === 'football'"
                class="d-flex justify-content-between flex-wrap"
              >
                <img
                  src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/pg-boss/cards/Body.png"
                  alt="football"
                  class="my-2 px-0 mx-0"
                  style="cursor: pointer; width: 49%; height: auto;"
                  @click="$router.push('/body-fb')"
                >
                <img
                  src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/pg-boss/cards/Maung.png"
                  alt="football"
                  class="my-2 px-0 mx-0"
                  style="cursor: pointer; width: 49%; height: auto;"
                  @click="$router.push('/maung-fb')"
                >
                <!-- <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/hulk333/general/hulk_live.png" alt="skm" class="my-2 px-0 mx-0" style="cursor: pointer; width: 49%; height: auto;" @click="$router.push('/Live')"> -->
              </div>

              <div
                :class="$store.state.sideNav === 'arcade' ? 'active' : ''"
                v-if="$store.state.sideNav === 'arcade'"
                class="home-provider-grid d-flex justify-content-between flex-wrap"
              >
                <img
                  src="https://storage.googleapis.com/spacetech2/CR7/RICH88%20CARD%20(1).webp"
                  alt="Rich88"
                  class="home-provider-card home-provider-card--spaced"
                  @click="$router.push('/user/arcade?provider=Rich88')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/CR7/JILI%20ACD.webp"
                  alt="Jili"
                  class="home-provider-card home-provider-card--spaced"
                  @click="$router.push('/user/arcade?provider=Jili')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/CR7/BNG%20CARD.webp"
                  alt="BNG"
                  class="home-provider-card home-provider-card--spaced"
                  @click="$router.push('/user/arcade?provider=BNG')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/CR7/BT%20ACD.webp"
                  alt="BTG"
                  class="home-provider-card home-provider-card--spaced"
                  @click="$router.push('/user/arcade?provider=BTG')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/CR7/FC%20ACD.webp"
                  alt="FaChai"
                  class="home-provider-card home-provider-card--spaced"
                  @click="$router.push('/user/arcade?provider=FaChai')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/CR7/PP%20ACD.webp"
                  alt="Pragmatic"
                  class="home-provider-card home-provider-card--spaced"
                  @click="$router.push('/user/arcade?provider=Pragmatic')"
                >
              </div>

              <div
                :class="$store.state.sideNav === 'liveCasino' ? 'active' : ''"
                v-if="$store.state.sideNav === 'liveCasino'"
                class="d-flex justify-content-between flex-wrap"
              >
                <img
                  src="https://storage.googleapis.com/spacetech2/cr7/LiveCasino.avif"
                  alt="casino"
                  class="my-2 px-0 mx-0"
                  style="cursor: pointer; width: 48%; height: auto;"
                  @click="gameInitCasino('PP Live')"
                >
              </div>

              <div
                :class="$store.state.sideNav === 'card' ? 'active' : ''"
                v-if="$store.state.sideNav === 'card'"
                class="home-provider-grid d-flex justify-content-between flex-wrap"
              >
                <img
                  src="https://storage.googleapis.com/spacetech2/cr7/assets/SKM.avif"
                  alt="SKM"
                  class="home-provider-card home-provider-card--wide"
                  @click="changeSideNav('skm')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/cr7/assets/BuuGyi.avif"
                  alt="BuuGyi"
                  class="home-provider-card home-provider-card--wide"
                  @click="changeSideNav('bgy')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/cr7/assets/Spin.avif"
                  alt="Spin"
                  class="home-provider-card home-provider-card--wide"
                  @click="fetchForestData()"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/cr7/assets/Galon.avif"
                  alt="Galon"
                  class="home-provider-card home-provider-card--wide"
                  @click="fetchGaloneGalone()"
                >
              </div>

              <div
                :class="$store.state.sideNav === 'download' ? 'active' : ''"
                v-if="$store.state.sideNav === 'download'"
              >
                <div class="gwrap_1 pb-3">
                  <h4 class="text-center text-white mt-3">{{ $t('home.you_download') }} <br>
                    {{ $t('home.on_any_platform') }}</h4>
                  <a
                    href="https://backapi.space97.vip/api/app/download/android"
                    download="melonzeed.apk"
                  >
                    <img
                      src="https://cdn.gold549.com/build/assets/img/brand/android-download.png"
                      alt="slot"
                      style="cursor: pointer; width: 50%; height: auto;"
                    >
                  </a>
                  <a
                    href="https://backapi.space97.vip/api/app/download/ios"
                    download="melonzeed.mobileconfig"
                  >
                    <img
                      src="https://cdn.gold549.com/build/assets/img/brand/ios-download.png"
                      alt="slot"
                      style="cursor: pointer; width: 50%; height: auto; margin-top: 0.1rem;"
                    >
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
    </div>

    <van-overlay :show="isLoading">
      <div
        class="wrapper"
        @click.stop
      >
        <van-loading
          type="spinner"
          color="#ffffff"
          class="mx-auto"
        />
      </div>
    </van-overlay>

    <!-- <LiveChatWidget license="18638211" v-if="testing"/> -->

  </div>
</template>
<script>
import NavBar from '@/layouts/NavBar.vue';
import { NoticeBar, Dialog, Toast, Sticky } from 'vant';
import { mapActions } from 'vuex';
import { LiveChatWidget } from '@livechat/widget-vue';
import GameThumbImg from '@/components/GameThumbImg.vue';
import {
  getGameUrlFromGamesUrlResponse,
  getGameLaunchBusinessMessage,
  getGameUrlMissingLaunchBody,
} from '@/utils/gameUrlApiError';
import {
  showGameUrlErrorDialog,
  showGameUrlClientError,
  showStyledAppAlert,
} from '@/utils/showGameUrlErrorDialog';

export default {
  components: { NoticeBar, Sticky, LiveChatWidget, GameThumbImg },
  data() {
    return {
      testing: true,
      isLoading: false,
      twoDdata: {},
      twoDHistories: {},
      threeDHistories: {},
      threedData: {},
      websiteInfo: {
        home_banners: {},
        noticeText: 'This is a notice',
      },
      isLogged: false,
      hotGames: [],
    };
  },
  destroyed() {
    this.testing = false;
  },
  methods: {
    async gameInitCasino(game) {
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push('/auth/login');
        }

        const res = await axios.get('/games/url', {
          params: {
            provider: game
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        const launchUrl = getGameUrlFromGamesUrlResponse(res);
        if (!launchUrl) {
          const lang = this.$store.state.language === 'en' ? 'en' : 'mm';
          showGameUrlClientError(getGameUrlMissingLaunchBody(res, lang), lang);
          this.isLoading = false;
          return;
        }
        window.location.assign(launchUrl);

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        showGameUrlErrorDialog(
          error,
          this.$store.state.language === 'en' ? 'en' : 'mm',
          this.$store.state.language === 'en'
            ? 'Unable to open the game.'
            : 'ဂိမ်းဖွင့်၍မရပါ။',
        );
      }
    },
    showCardGameMoneyLimitNotice(message) {
      const lang = this.$store.state.language === 'en' ? 'en' : 'mm';
      const isEn = lang === 'en';
      showStyledAppAlert(message, lang, {
        title: isEn ? 'Important notice' : 'အထူးသတိပြုရန်',
      });
    },
    showStyledCardLaunchEmptyResponse(res) {
      const lang = this.$store.state.language === 'en' ? 'en' : 'mm';
      const isEn = lang === 'en';
      const msg =
        getGameLaunchBusinessMessage(res) ||
        (isEn ? 'Unable to start the game.' : 'ဂိမ်းစတင်မရပါ။');
      showStyledAppAlert(msg, lang, {
        title: isEn ? 'Cannot open game' : 'ဂိမ်းဖွင့်မရပါ',
        confirmButtonText: isEn ? 'Go Back' : 'နောက်သို့ပြန်သွားမည်။',
      });
    },
    async gameInit(game) {
      try {
        this.$store.commit('setLoading', true);

        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push('/auth/login');
          return;
        }

        // PGSoft launch (redirect directly to backend)
        if (game.provider === 'PGSoft') {
          this.$store.commit('setLoading', false);
          window.location.href = `/games/url?gameID=${game.gameID}&provider=pgsoft`;
          return;
        }

        // Other providers
        const res = await axios.get('/games/url', {
          params: {
            gameID: game.gameID,
            provider: game.provider
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        const launchUrl = getGameUrlFromGamesUrlResponse(res);
        if (!launchUrl) {
          const lang = this.$store.state.language === 'en' ? 'en' : 'mm';
          showGameUrlClientError(getGameUrlMissingLaunchBody(res, lang), lang);
          this.$store.commit('setLoading', false);
          return;
        }
        window.top.location.href = launchUrl;

        this.$store.commit('setLoading', false);

      } catch (error) {
        this.$store.commit('setLoading', false);
        showGameUrlErrorDialog(
          error,
          this.$store.state.language === 'en' ? 'en' : 'mm',
          this.$store.state.language === 'en'
            ? 'Unable to open the game.'
            : 'ဂိမ်းဖွင့်၍မရပါ။',
        );
      }
    },

    imageLinkGenerate(gameId, type) {
      if (type === 'Jili') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/jili/${gameId}.webp`;
      }
      if (type === 'Live22') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/live22/${gameId}.webp`;
      }
      if (type === 'Spade') {
        return `https://merchantapi.silverkirin88.com/thumbnail/en_US/${gameId}.jpg`;
      }
      if (type === 'Fastspin') {
        return `http://api-egame-staging.fsuat.com/thumbnail/en_US/${gameId}.jpg`;
      }
      if (type === 'Playstar') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/playstar/${gameId}.webp`;
      }
      if (type === 'FaChai') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/fachai/${gameId}.webp`;
      }
      if (type === 'PGSoft') {
        return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/pgsoft/pgsoft_${gameId}.webp`;
      }
      if (type === 'JOKER' || type === 'Joker') {
        return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/joker/${gameId}.webp`;
      }
      if (type === '5G') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/5g/${gameId}.webp`;
      }
      if (type === 'KA') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/newKA/${gameId}.webp`;
      }
      if (type === 'AceWin') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/acewin/${gameId}_EN.webp`;
      }
      if (type === 'JDB') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/jdb/${gameId}.webp`;
      }
      if (type === 'Buffalo') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/pp/${gameId}.webp`;
      }
      if (type === 'HotDog') {
        return `https://res.hotdog-gaming.com/banners/380x500/${gameId}.png`;
      }
      if (type === 'Rich') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/rich/${gameId}.webp`;
      }
      if (type === 'Rich88') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/rich88/${gameId}.webp`;
      }
      if (type === 'CQ9' || type === 'cq9' || type === 'SexySlot') {
        return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/cq9/cq9_${gameId}.webp`;
      }
      if (type === 'BTG') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/btg/${gameId}.webp`;
      }
      if (type === '2J') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/2j/${gameId}.webp`;
      }
      if (type === 'VA') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/va/${gameId}_en.webp`;
      }
      if (type === 'BNG') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/bng/${gameId}.webp`;
      }
      if (type === 'AfricanBuffalo') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/afb/${gameId}.webp`;
      }

      return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/pp/${gameId}.webp`;
    },
    scrollToElement() {
      const container = this.$el.querySelector('.index_rightbar');
      // Scroll to the target element within the container
      if (container) {
        container.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    },
    async fetchBetGame(game = null, link = null) {
      try {
        this.isLoading = true;

        if (game) {
          this.gameName = game
          this.gameLink = link
        }
        const res = await axios.get(`/${this.gameName}-data`, {
          params: {
            id: this.$store.state.authUser.name,
            balance: this.$store.state.authUser.amount,
            info: {
              nickname: this.$store.state.authUser.user_name,
              profile: 3
            }
          }
        });
        window.location.assign(`https://${link}.vercel.app/?id=${this.$store.state.authUser.name}&passcode=${res.data.passcode}&exit=https%3A%2F%2F${window.location.host}/home`)
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async fetchForestData() {
      // if(this.$store.state.authUser.game_balance < 1000) {
      //   this.alertBoxForLimit();
      //   return false;
      // } 
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push('/auth/login');
        }

        // if(this.nickname && this.nickname !== ''){
        const res = await axios.get('/forest-data', {
          params: {
            id: this.$store.state.authUser.name,
            balance: this.$store.state.authUser.game_balance,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        const launchUrl = getGameUrlFromGamesUrlResponse(res);
        if (launchUrl) {
          window.location.assign(launchUrl);
        } else {
          this.showStyledCardLaunchEmptyResponse(res);
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        showGameUrlErrorDialog(
          error,
          this.$store.state.language === 'en' ? 'en' : 'mm',
          this.$store.state.language === 'en'
            ? 'Unable to open the game.'
            : 'ဂိမ်းဖွင့်၍မရပါ။',
        );
      }
    },

    async fetchGaloneData() {
      // if(this.$store.state.authUser.game_balance < 1000) {
      //   this.alertBoxForLimit();
      //   return false;
      // } 
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push('/auth/login');
        }

        // if(this.nickname && this.nickname !== ''){
        const res = await axios.get('/galone-data', {
          params: {
            id: this.$store.state.authUser.name,
            balance: this.$store.state.authUser.game_balance,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        const launchUrl = getGameUrlFromGamesUrlResponse(res);
        if (launchUrl) {
          window.location.assign(launchUrl);
        } else {
          this.showStyledCardLaunchEmptyResponse(res);
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        showGameUrlErrorDialog(
          error,
          this.$store.state.language === 'en' ? 'en' : 'mm',
          this.$store.state.language === 'en'
            ? 'Unable to open the game.'
            : 'ဂိမ်းဖွင့်၍မရပါ။',
        );
      }
    },

    async fetchGaloneGalone() {
      if (this.$store.state.authUser.game_balance < 1000) {
        const lang = this.$store.state.language === 'en' ? 'en' : 'mm';
        showStyledAppAlert(
          lang === 'en'
            ? 'Your game balance is below 1,000. Please top up before continuing.'
            : '၁,၀၀၀ အောက်ရောက်နေပါသည်။ ငွေထံဖြည့်သွင်းပြီးမှ ဆက်လက်ကစားနိုင်ပါသည်။',
          lang,
          {
            title: lang === 'en' ? 'Important notice' : 'အထူးသတိပြုရန်',
          },
        );
        return false;
      }
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push('/auth/login');
        }

        // if(this.nickname && this.nickname !== ''){
        const res = await axios.get('/galone-galone', {
          params: {
            id: this.$store.state.authUser.name,
            balance: this.$store.state.authUser.game_balance,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        const launchUrl = getGameUrlFromGamesUrlResponse(res);
        if (launchUrl) {
          window.location.assign(launchUrl);
        } else {
          this.showStyledCardLaunchEmptyResponse(res);
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        showGameUrlErrorDialog(
          error,
          this.$store.state.language === 'en' ? 'en' : 'mm',
          this.$store.state.language === 'en'
            ? 'Unable to open the game.'
            : 'ဂိမ်းဖွင့်၍မရပါ။',
        );
      }
    },

    async fetchBugyee(level = null) {
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push('/auth/login');
        }

        const amount = authUser.amount;
        if (level == 0 && amount < 1000) {
          this.showCardGameMoneyLimitNotice("1,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။");
          this.isLoading = false;
          return false;
        }
        if (level == 0 && amount > 100000) {
          this.showCardGameMoneyLimitNotice("သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။");
          this.isLoading = false;
          return false;
        }

        if (level == 1 && amount < 3000) {
          this.showCardGameMoneyLimitNotice("3,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။");
          this.isLoading = false;
          return false;
        }
        if (level == 1 && amount > 300000) {
          this.showCardGameMoneyLimitNotice("သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။");
          this.isLoading = false;
          return false;
        }

        if (level == 2 && amount < 5000) {
          this.showCardGameMoneyLimitNotice("5,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။");
          this.isLoading = false;
          return false;
        }
        if (level == 2 && amount > 500000) {
          this.showCardGameMoneyLimitNotice("သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။");
          this.isLoading = false;
          return false;
        }

        if (level == 3 && amount < 10000) {
          this.showCardGameMoneyLimitNotice("10,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။");
          this.isLoading = false;
          return false;
        }
        if (level == 4 && amount < 30000) {
          this.showCardGameMoneyLimitNotice("30,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။");
          this.isLoading = false;
          return false;
        }
        if (level == 5 && amount < 50000) {
          this.showCardGameMoneyLimitNotice("50,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။");
          this.isLoading = false;
          return false;
        }

        const res = await axios.get('/bugyee-data', {
          params: {
            id: this.$store.state.authUser.name,
            level,
            balance: this.$store.state.authUser.amount,
            info: {
              nickname: this.$store.state.authUser.user_name,
              profile: 3
            }
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        const launchUrl = getGameUrlFromGamesUrlResponse(res);
        if (launchUrl) {
          window.location.assign(launchUrl);
        } else {
          this.showStyledCardLaunchEmptyResponse(res);
        }
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        showGameUrlErrorDialog(
          error,
          this.$store.state.language === 'en' ? 'en' : 'mm',
          this.$store.state.language === 'en'
            ? 'Unable to open the game.'
            : 'ဂိမ်းဖွင့်၍မရပါ။',
        );
      }
    },

    async fetchShanKoMeeData(level = null) {
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push('/auth/login');
        }

        const amount = authUser.amount;
        if (level == 0 && amount < 1000) {
          this.showCardGameMoneyLimitNotice("1,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။");
          this.isLoading = false;
          return false;
        }
        if (level == 0 && amount > 100000) {
          this.showCardGameMoneyLimitNotice("သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။");
          this.isLoading = false;
          return false;
        }

        if (level == 1 && amount < 3000) {
          this.showCardGameMoneyLimitNotice("3,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။");
          this.isLoading = false;
          return false;
        }
        if (level == 1 && amount > 300000) {
          this.showCardGameMoneyLimitNotice("သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။");
          this.isLoading = false;
          return false;
        }

        if (level == 2 && amount < 5000) {
          this.showCardGameMoneyLimitNotice("5,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။");
          this.isLoading = false;
          return false;
        }
        if (level == 2 && amount > 500000) {
          this.showCardGameMoneyLimitNotice("သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။");
          this.isLoading = false;
          return false;
        }

        if (level == 3 && amount < 10000) {
          this.showCardGameMoneyLimitNotice("10,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။");
          this.isLoading = false;
          return false;
        }
        if (level == 4 && amount < 30000) {
          this.showCardGameMoneyLimitNotice("30,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။");
          this.isLoading = false;
          return false;
        }
        if (level == 5 && amount < 50000) {
          this.showCardGameMoneyLimitNotice("50,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။");
          this.isLoading = false;
          return false;
        }

        // if(this.nickname && this.nickname !== ''){
        const res = await axios.get('/shankomee-data', {
          params: {
            id: this.$store.state.authUser.name,
            level,
            balance: this.$store.state.authUser.amount,
            info: {
              nickname: this.$store.state.authUser.user_name,
              profile: 3
            }
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        const launchUrl = getGameUrlFromGamesUrlResponse(res);
        if (launchUrl) {
          window.location.assign(launchUrl);
        } else {
          this.showStyledCardLaunchEmptyResponse(res);
        }
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        showGameUrlErrorDialog(
          error,
          this.$store.state.language === 'en' ? 'en' : 'mm',
          this.$store.state.language === 'en'
            ? 'Unable to open the game.'
            : 'ဂိမ်းဖွင့်၍မရပါ။',
        );
      }
    },
    // async gameInit(game) {
    //   try {
    //     this.isLoading = true;
    //     const authUser = await this.fetchUser();
    //     if (!authUser) {
    //       this.$router.push('/auth/login');
    //     }

    //     const res = await axios.get('/games/url', {
    //       params: {
    //         provider: game
    //       },
    //       headers: {
    //         Authorization: `Bearer ${localStorage.getItem('token')}`,
    //       },
    //     });

    //     window.open(res.data.data.gameUrl, "_self");
    //     // this.$store.commit('setIframeURL', res.data.data.gameUrl);
    //     // this.$store.commit('setIsCardGame', false);
    //     // this.$router.push('/iframeURL');

    //     this.isLoading = false;
    //   } catch (error) {
    //     this.isLoading = false;
    //     // this.$router.go();
    //   }
    // },
    hotGameDisplayName(slotGame) {
      const raw = slotGame && slotGame.name != null ? String(slotGame.name).trim() : '';
      if (!raw) return '';
      const prov = slotGame.provider ? String(slotGame.provider).trim() : '';
      if (!prov) return raw;
      const esc = prov.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      let s = raw.replace(new RegExp(`^${esc}\\s*[|\\-–—:]\\s*`, 'i'), '');
      s = s.replace(new RegExp(`\\s*[|\\-–—:]\\s*${esc}$`, 'i'), '');
      s = s.replace(new RegExp(`^${esc}\\s+`, 'i'), '');
      s = s.replace(new RegExp(`\\s+${esc}$`, 'i'), '');
      s = s.replace(new RegExp(`^\\[${esc}\\]\\s*`, 'i'), '');
      s = s.trim();
      return s || raw;
    },

    changeSideNav(para) {
      // this.sideNav = para;
      this.$store.commit('updateSideNav', para);
      this.scrollToElement()
    },
    ...mapActions(['logoutUser', 'fetchUser']),
    async redirectRoute(path, query = null) {
      try {
        console.log('query', query)
        if (query) {
          this.$router.push({ path, query });
        } else {
          this.$router.push(path);
        }
      } catch (error) {
        console.log(error);
      }
    },

    logout() {
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure to log out?'
            : 'ထွက်မှာ သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မထွက်တော့ပါ',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ',
      })
        .then(async () => {
          await this.logoutUser();
          this.$router.push('/auth/login');
          Toast.success(
            this.$store.state.language === 'en' ? 'Logged out!' : 'ထွက်ပြီးပြီ'
          );
        })
        .catch(() => { });
    },
    async redirectRoute(path, query = null) {
      try {
        if (path === 'tip') {
          const text = this.$store.state.language === 'en'
            ? 'This feature is not support yet.'
            : 'ယခုအချိန်တွင် အသုံးပြုလို့မရနိုင်သေးပါ။';
          showStyledAppAlert(text, this.$store.state.language === 'en' ? 'en' : 'mm', {
            confirmButtonText: 'Okay',
          });
        } else if (query) {
          this.$router.push({ path, query });
        } else {
          this.$router.push(path);
        }
      } catch (error) {
        console.log(error);
      }
    },
    threedDrawDateFormat(date) {
      return moment(date).format('ll');
    },
    async fetchTwoDdata() {
      try {
        const res = await axios.get('/2d/data');
        this.isLive = res.data.data[0].isLive;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchWebsiteData() {
      try {
        const res = await axios.get('/website-infos');
        this.websiteInfo = res.data.data[0];
      } catch (error) {
        console.log(error);
      }
    },
    async fetchThreedDdata() {
      try {
        const res = await axios.get('/3d/data');
        this.threedData = res.data.data[0];
      } catch (error) {
        console.log(error);
      }
    },
    async fetchHotGames() {
      try {
        const res = await axios.get('/hot-games');
        this.hotGames = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchTwoThreeDHistories() {
      try {
        const twoDres = await axios.get('/twod_history');
        const threeDres = await axios.get('/threed_history');
        this.twoDHistories = twoDres.data.data;
        this.threeDHistories = threeDres.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    // Function to load the Tawt.io chat widget
    // loadTawkChat() {
    //   console.log('here1')
    //   if (!document.getElementById('tawk-io-chat')) {
    //     console.log('here2')
    //     var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();

    //     // Dynamically add the script to load Tawt.io
    //     var s1 = document.createElement("script");
    //     var s0 = document.getElementsByTagName("script")[0];
    //     s1.async = true;
    //     s1.id = 'tawk-io-chat';
    //     s1.src = 'https://embed.tawk.to/66ed95584cbc4814f7dc1919/1i880up29';
    //     s1.charset = 'UTF-8';
    //     s1.setAttribute('crossorigin', '*');
    //     s0.parentNode.insertBefore(s1, s0);

    //     // Apply custom styles when the widget loads
    //     Tawk_API.onLoad = () => {
    //       this.applyCustomStyles();
    //       setInterval(this.applyCustomStyles, 1000);
    //     };
    //   }
    // },
    // Function to apply custom styles to the Tawk.to iframe
    // applyCustomStyles() {
    //   var tawkIframe = document.querySelector('iframe[title="chat widget"]');
    //   if (tawkIframe) {
    //     tawkIframe.style.bottom = '7rem'; // Adjust this as needed
    //     tawkIframe.style.left = '1rem'; 
    //     tawkIframe.style.right = '0rem'; 
    //   }
    // },
    // // Function to remove the Tawt.io script and widget
    // removeTawkChat() {
    //   const tawkScript = document.getElementById('tawk-io-chat');
    //   if (tawkScript) {
    //     tawkScript.remove(); // Remove the script tag
    //   }

    //   // Remove the Tawk.to iframe widget
    //   const tawkIframe = document.querySelector('iframe[title="chat widget"]');
    //   if (tawkIframe) {
    //     tawkIframe.remove();
    //   }
    // }
  },
  async mounted() {
    this.$store.commit('setLoading', true);
    await this.fetchWebsiteData();
    await this.fetchHotGames();
    this.$store.commit('setLoading', false);
  },
  beforeDestroy() {
    // this.removeTawkChat();
  }
};
</script>
<style scoped>
.home-hot-game-thumb {
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 4;
  border-radius: 10px;
  overflow: hidden;
}

.home-provider-grid {
  gap: 0.35rem 0;
}

.home-provider-card {
  width: 31%;
  height: auto;
  margin: 0.5rem 0;
  padding: 0;
  display: block;
  cursor: pointer;
  border-radius: 12px;
  object-fit: cover;
  border: 1px solid rgba(210, 160, 56, 0.3);
  box-shadow:
    0 4px 14px rgba(0, 0, 0, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.06);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    border-color 0.2s ease;
}

.home-provider-card:hover {
  transform: translateY(-3px);
  border-color: rgba(210, 160, 56, 0.65);
  box-shadow:
    0 10px 24px rgba(0, 0, 0, 0.5),
    0 0 16px rgba(210, 160, 56, 0.12);
}

.home-provider-card:active {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.35);
}

.home-provider-card--wide {
  width: 48%;
}

.home-provider-card--spaced {
  margin-top: 0.9rem;
}

.home-hot-game-thumb ::v-deep .game-thumb-wrap {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  min-height: 0;
}

.pulse {
  -webkit-animation-name: pulse;
  animation-name: pulse;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}

@-webkit-keyframes pulse {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }

  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

@keyframes pulse {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }

  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

/* Home page horizontal category tabs — full width, equal columns */
.home-side-nav {
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: hidden;
  gap: 0.25rem;
  flex-wrap: nowrap;
}

.home-side-nav-item {
  flex: 1 1 0;
  min-width: 0;
  max-width: none;
}

.home-side-nav-tile {
  width: 100%;
  min-height: 5.25rem;
  height: auto;
  box-sizing: border-box;
  padding: 0.45rem 0.25rem 0.5rem;
  border-radius: 12px;
  overflow: visible;
}

.home-side-nav-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  flex-shrink: 0;
  border-radius: 12px;
  background: radial-gradient(circle at 50% 35%,
      rgba(210, 160, 56, 0.14) 0%,
      rgba(25, 22, 18, 0.85) 65%);
  border: 1px solid rgba(210, 160, 56, 0.22);
  box-shadow:
    0 3px 10px rgba(0, 0, 0, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.07);
  transition:
    transform 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;
}

.home-side-nav-icon-wrap--compact {
  width: 2.85rem;
  height: 2.85rem;
}

.home-side-nav-icon-img {
  width: 2.5rem;
  height: 2.5rem;
  max-height: 2.5rem;
  object-fit: contain;
  flex-shrink: 0;
  cursor: pointer;
  display: block;
  filter: drop-shadow(0 2px 5px rgba(0, 0, 0, 0.45));
  transition: transform 0.2s ease;
}

.home-side-nav-icon-img--compact {
  width: 2.35rem;
  height: 2.35rem;
  max-height: 2.35rem;
}

.home-side-nav-label {
  display: block;
  width: 100%;
  max-width: 100%;
  margin-top: 0.35rem;
  padding: 0 1px;
  font-size: 0.68rem;
  line-height: 1.2;
  text-align: center;
  word-break: break-word;
  overflow-wrap: anywhere;
  hyphens: auto;
  box-sizing: border-box;
}

.side-nav-icon-text {
  /* color: #A80000; */
  font-size: 0.68rem;
  /* color: #382618; */
}

.side-nav-icon {
  position: relative;
  cursor: pointer;
  overflow: visible;
  font-weight: 600;
  color: #ccc !important;
  background: linear-gradient(180deg,
      rgba(28, 26, 22, 0.95) 0%,
      rgba(18, 16, 14, 0.98) 100%);
  border: 1px solid rgba(87, 73, 54, 0.85);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  transition:
    transform 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;
}

.side-nav-icon:hover {
  transform: translateY(-2px);
  border-color: rgba(210, 160, 56, 0.45);
  box-shadow:
    0 8px 18px rgba(0, 0, 0, 0.4),
    0 0 12px rgba(210, 160, 56, 0.08);
}

.side-nav-icon:hover .home-side-nav-icon-wrap {
  border-color: rgba(210, 160, 56, 0.45);
  transform: scale(1.04);
}

.side-nav-icon:hover .home-side-nav-icon-img {
  transform: scale(1.06);
}

.side-nav-icon.active {
  background: linear-gradient(180deg,
      rgba(42, 34, 24, 0.98) 0%,
      rgba(24, 20, 14, 1) 100%);
  border: 1px solid #D2A038 !important;
  box-shadow:
    0 6px 16px rgba(0, 0, 0, 0.45),
    0 0 18px rgba(210, 160, 56, 0.12);
}

.side-nav-icon.active .home-side-nav-icon-wrap {
  border-color: rgba(210, 160, 56, 0.6);
  background: radial-gradient(circle at 50% 35%,
      rgba(255, 197, 0, 0.22) 0%,
      rgba(35, 28, 18, 0.9) 70%);
  box-shadow:
    0 0 14px rgba(210, 160, 56, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

.side-nav-icon.active .home-side-nav-icon-img {
  transform: scale(1.05);
}

.side-nav-icon:active {
  transform: translateY(0);
}

.side-nav-icon-text.active {
  background: linear-gradient(to bottom, #ffc500 0%, #ff4500 50%, #c71600 100%);
  color: white;
  border: none;
  width: 100%;
  max-width: 100%;
  text-align: center;
  border-radius: 6px;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
  padding: 3px 5px;
  box-sizing: border-box;
  white-space: normal;
  line-height: 1.2;
}

.side-nav-icon-text:not(.active) {
  color: #b8b0a4;
}

.sidebar {
  position: fixed;
  /* top: 23.5rem; */
  left: 0;
  height: 55vh;
  padding-bottom: 50px;
  scrollbar-width: none;
  /* For Firefox */
  -ms-overflow-style: none;
  /* For Internet Explorer and Edge */
  overflow-y: auto;
}

.index_rightbar {
  padding: 0px 10px;
  overflow-y: scroll;
  height: 55vh;
  scrollbar-width: none;
  /* For Firefox */
  -ms-overflow-style: none;
  /* For Internet Explorer and Edge */
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.detail-button {
  appearance: none;
  background-color: transparent;
  border: 2px solid #714DC7;
  text-transform: uppercase;
  border-radius: 10px;
  box-sizing: border-box;
  color: #714DC7;
  cursor: pointer;
  display: inline-block;
  font-family: Roobert, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 0.9rem;
  font-weight: 450;
  line-height: normal;
  margin: 0;
  min-height: 15px;
  min-width: 0;
  outline: none;
  padding: 5px 10px;
  text-align: center;
  text-decoration: none;
  transition: all 300ms cubic-bezier(.23, 1, 0.32, 1);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 100%;
  will-change: transform;
}

.detail-button:disabled {
  pointer-events: none;
}

.detail-button:hover {
  color: #fff;
  background-color: #714DC7;
  box-shadow: rgba(0, 0, 0, 0.25) 0 8px 15px;
  transform: translateY(-2px);
}

.detail-button:active {
  box-shadow: none;
  transform: translateY(0);
}

.nav-pills.game-nav {
  padding-right: 5px;
}

.nav-pills .nav-link {
  border-radius: 10px !important;
  margin-bottom: 5px;
  /* padding: 10px; */
  font-size: 10px !important;
  text-align: center;
  color: #ffffff;
  /* background: linear-gradient(#aa9ace, #714DC7); */
}

.nav-item {
  padding-right: 0;
  margin-bottom: 0;
  width: 12rem;
}

.nav-pills .nav-link img {
  width: 18px !important;
  /* margin-right: 10px; */
  padding-bottom: 4px;
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
  color: #fff !important;
  background: linear-gradient(#fff, #8a69d9);
}

.nav {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.tab-content.game a img {
  /* box-shadow: 0px 3px 14px -5px rgba(0, 0, 0, 0.4); */
  border-radius: 21px;
  margin-bottom: 10px;
  width: 100%;
}

.tab-content.game {
  padding-left: 3px;
}

.tab-content>.tab-pane {
  display: none;
  padding-right: 3px;
}

.tab-content>.active {
  display: block;
}


.css-38745a {
  margin: 0px;
  line-height: 1.5;
  font-size: 12px;
  font-family: NotoSansMyanmar;
  font-weight: 500;
}

.css-17h40hp {
  margin: 0px;
  line-height: 1.5;
  font-size: 14px;
  font-family: NotoSansMyanmar;
  font-weight: 700 !important;
}

.card {
  cursor: pointer;
  border-radius: 10px !important;
}

.main-image-wrapper img {
  width: 100%;
}

.video-container {
  height: 500px;
  width: 100%;
}

.notice-bar {
  margin-top: -40px;
  z-index: 1;
  font-size: 20px;
  color: white !important;
  background: transparent;
}

.twod-threed-cards {
  height: 200px;
}

.live-number {
  font-weight: bold;
  font-size: 25px;
}

.live-result {
  font-weight: bolder;
  font-size: 60px;
  animation-name: live-number-animation;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

.not-live-text {
  font-weight: bold;
  font-size: 24px;
}

.cards-container {
  display: flex;
  flex-wrap: wrap;
}

.card-body {
  padding: 0px !important;
}

.cards-container-mobile {
  display: none;
}

@keyframes live-number-animation {
  from {
    color: white;
  }

  to {
    color: red;
  }
}

/* @media (max-width: 768px) { */
/* .middle-container {
    padding-top: 0.1rem !important;
  } */
hr {
  margin-top: 0px;
  margin-bottom: 0px;
}

.video-container {
  height: 300px;
  width: 100%;
}

.main-wrapper {
  padding: 7px !important;
}

.notice-bar {
  margin-top: 0px;
  height: 25px;
  z-index: 1;
  font-size: 1rem;
  color: rgb(162 141 96 / 1) !important;
  background: transparent;
  border-radius: 7px;
}

.live-number {
  font-weight: bold;
  font-size: 20px;
}

.live-result {
  font-weight: bolder;
  font-size: 37px;
}

.cards-container {
  display: none;
}

.cards-container-mobile {
  padding: 0px !important;
  margin-top: 5px !important;
  display: flex;
  flex-wrap: wrap;
}

.home-cards {
  padding-left: 10px;
  padding-right: 10px;
}

.card-body {
  padding: 0px !important;
}

.not-live-text {
  font-size: 18px;
  padding-left: 10px;
  padding-right: 10px;
}

.account-container-wrapper {
  width: auto;
  height: auto;
  border-radius: 10px;
  padding-left: 4px;
  padding-right: 4px;
  margin-top: 10px !important;
  margin-left: 10px;
  margin-right: 10px;
  color: #000000;
  /* background: linear-gradient(#aa9ace, #714DC7); */
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}

.top-wrapper,
.bottom-wrapper {
  padding: 10px;
  width: 100%;
  display: flex;
}

.top-right,
.bottom-right {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: end;
}

.top-left,
.bottom-left {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: start;
}

/* } */
</style>
